var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chessman flex items-center"},[_c('img',{attrs:{"src":_vm.pieceImg,"alt":_vm.piece.captured}})])
}
var staticRenderFns = []

export { render, staticRenderFns }